//Import required libraries
import React from "react";

//Import custom components

//Import Styles

const Error = () => {
  return (
    <div className="page-not-found">
      <i class="fa fa-frown-o" aria-hidden="true"></i>
      <h1>Page not found</h1>
    </div>
  );
};

export default Error;
